
import React from "react";
import { Routes, Route } from "react-router-dom";
import ApplyPage from "pages/Document/Apply";

const DocumentRoute = () => (
    <Routes>
        <Route path="/apply" element={<ApplyPage />}></Route>
    </Routes>
)

export default DocumentRoute;